//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import { StreamsDeprecationBanner } from '@streams-drawer/components/StreamsDeprecationBanner';

angular.module('curalate').component('streamsDrawerDeprecationBanner', {
  controller: makeAngularReactController(<StreamsDeprecationBanner />),
});
